export enum Time {
  MINUTESINYEAR = 60 * 24 * 365,
  // Some month have 30 or 31 or 28 days so 60 * 24 * 30 gives 43200 which is not right.
  // Google gives 43800 which is avg minutes of a single month.
  MINUTESINMONTH = 43800,
  MINUTESINDAY = 60 * 24,
  MINUTESINHOUR = 60,
}
